import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';

export const shipments = {
  id: 'SHIPMENTS',
  apiKey: 'Shipment',
  component: <FormattedMessage {...messages.shipment} />,
};

export const fulfillments = {
  id: 'FULFILLMENTS',
  apiKey: 'Fulfillment',
  component: <FormattedMessage {...messages.fulfillments} />,
};

export const returns = {
  id: 'RETURNS',
  apiKey: 'Returns',
  component: <FormattedMessage {...messages.returns} />,
};

export const batches = {
  id: 'BATCHES',
  apiKey: 'Batches',
  component: <FormattedMessage {...messages.batches} />,
};

export const fulfillmentTypeOptions = [shipments, fulfillments, batches, returns];
